import React, { useEffect, useState } from "react";
import { Veiculo } from "../../../Models/Cadastros/Veiculo/Veiculo";
import DropDownListComponent from "../../../Components/Forms/DropDownListComponent";
import TextFieldComponent from "../../../Components/Forms/TextFieldComponent";
import axios from "axios";

const VeiculoDadosTab = (props: any) => {
    const [veiculo, setVeiculo] = useState<any>(new Veiculo());
    const [ufs, setUfs] = useState<any[]>([]);
    const [veiculoMarcas, setVeiculoMarcas] = useState<any[]>([]);
    const [vinculos, setVinculos] = useState<any[]>([]);
    const [veiculoCores, setVeiculoCores] = useState<any[]>([]);
    const [tecnologias, setTecnologias] = useState<any[]>([]);
    const [tecnologiaComunicacoes, setTecnologiaComunicacoes] = useState<any[]>([]);
    const [veiculoTipos, setVeiculoTipos] = useState<any[]>([]);

    const optionSelecaoValue = [
        { label: 'FROTA', value: 1 },
        { label: 'AGREGADO', value: 2 },
        { label: 'CARRETEIRO', value: 3 },
    ];

    useEffect(() => {
        (async () => {
            let responseUfs: any = await axios.get('buscaEstados');
            setUfs(responseUfs.data);

            let responseVinculos: any = await axios.get('veiculoVinculos');
            setVinculos(responseVinculos.data);

            let responseVeiculoMarcas: any = await axios.get('veiculoMarcas');
            setVeiculoMarcas(responseVeiculoMarcas.data);

            let responseVeiculoCores: any = await axios.get('veiculoCores');
            setVeiculoCores(responseVeiculoCores.data);

            let responseTecnologias: any = await axios.get('tecnologias');
            setTecnologias(responseTecnologias.data);

            let responseTecnologiaComunicacoes: any = await axios.get('tecnologiaComunicacoes');
            setTecnologiaComunicacoes(responseTecnologiaComunicacoes.data);

            let responseVeiculoTipos: any = await axios.get('veiculoTipos');
            setVeiculoTipos(responseVeiculoTipos.data);
        })();
    }, []);

    useEffect(() => {
        setVeiculo(props.veiculo);
    }, [props.veiculo]);

    return (
        <div className="row">
            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12  mb-2">
                <TextFieldComponent
                    required
                    label="Placa"
                    field='placa'
                    model={veiculo} />
            </div>

            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12  mb-2">
                <TextFieldComponent
                    required
                    label="Renavan"
                    field='renavan'
                    model={veiculo} />
            </div>

            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12  mb-2">
                <DropDownListComponent
                    label='Marca'
                    required
                    options={veiculoMarcas}
                    valueField='id'
                    textField='descricao'
                    model={veiculo}
                    modelField='marca_id' />
            </div>

            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12  mb-2">
                <TextFieldComponent
                    label="Modelo"
                    field='modelo'
                    model={veiculo} />
            </div>

            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12  mb-2">
                <DropDownListComponent
                    label='Cor'
                    required
                    options={veiculoCores}
                    valueField='id'
                    textField='descricao'
                    model={veiculo}
                    modelField='cor_id' />
            </div>

            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12  mb-2">
                <TextFieldComponent
                    label="Ano Fab.:"
                    field='ano'
                    model={veiculo} />
            </div>

            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12  mb-2">
                <DropDownListComponent
                    label='Tipo'
                    required
                    options={veiculoTipos}
                    valueField='id'
                    textField='descricao'
                    model={veiculo}
                    modelField='tipo_id' />
            </div>

            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12  mb-2">
                <TextFieldComponent
                    label="Capacidade"
                    field='capacidade'
                    model={veiculo} />
            </div>

            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12  mb-2">
                <TextFieldComponent
                    label="Número Frota"
                    field='numero_frota'
                    model={veiculo} />
            </div>

            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12  mb-2">
                <TextFieldComponent
                    label="Número Nº Registro ANTT"
                    field='numero_antt'
                    model={veiculo} />
            </div>

            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12  mb-2">
                <TextFieldComponent
                    label="Validade ANTT"
                    field='validade_antt'
                    model={veiculo} />
            </div>

            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12  mb-2">
                <DropDownListComponent
                    label='Vínculo'
                    required
                    options={vinculos}
                    valueField='id'
                    textField='descricao'
                    model={veiculo}
                    modelField='vinculo_id' />
            </div>

            <br/>
            <h6>Dados do Proprietário</h6>
            <br/>

            <div className="col-xl-9 col-lg-9 col-md-8 col-sm-12 col-12  mb-2">
                <TextFieldComponent
                    label="Proprietário"
                    field='proprietario'
                    model={veiculo} />
            </div>

            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12  mb-2">
                <TextFieldComponent
                    label="CPF/CNPJ"
                    field='proprietario_cpfcnpj'
                    model={veiculo} />
            </div>

            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12  mb-2">
                <TextFieldComponent
                    label="Cep"
                    field='end_cep'
                    model={veiculo} />
            </div>

            <div className="col-xl-6 col-lg-6 col-md-4 col-sm-12 col-12  mb-2">
                <TextFieldComponent
                    label="Rua"
                    field='end_rua'
                    model={veiculo} />
            </div>

            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12  mb-2">
                <TextFieldComponent
                    label="Número"
                    field='end_numero'
                    model={veiculo} />
            </div>

            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12  mb-2">
                <TextFieldComponent
                    label="Complemento"
                    field='end_complemento'
                    model={veiculo} />
            </div>

            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12  mb-2">
                <TextFieldComponent
                    label="Bairro"
                    field='end_bairro'
                    model={veiculo} />
            </div>

            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12  mb-2">
                <TextFieldComponent
                    label="Cidade"
                    field='end_cidade'
                    model={veiculo} />
            </div>

            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12  mb-2">
                <DropDownListComponent
                    label='UF'
                    required
                    options={ufs}
                    valueField='id'
                    textField='sigla'
                    model={veiculo}
                    modelField='end_uf_id' />
            </div>

        <br/>
            <h6>Rastreador Primário</h6>
        <br/>

            <div className="col-xl-5 col-lg-5 col-md-4 col-sm-12 col-12  mb-2">
                <DropDownListComponent
                    label='Tecnologia Primaria'
                    required
                    options={tecnologias}
                    valueField='id'
                    textField='descricao'
                    model={veiculo}
                    modelField='tecnologia_id' />
            </div>

            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12  mb-2">
                <TextFieldComponent
                    label="Nº Rastreador Primário"
                    field='id_rastreador'
                    model={veiculo} />
            </div>

            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12  mb-2">
                <DropDownListComponent
                    label='Comunicação'
                    required
                    options={tecnologiaComunicacoes}
                    valueField='id'
                    textField='descricao'
                    model={veiculo}
                    modelField='tecnologia_comunicacao_id' />
            </div>

            <br/>
            <h6>Rastreador Secundário</h6>
            <br/>

            <div className="col-xl-5 col-lg-5 col-md-4 col-sm-12 col-12  mb-2">
                <DropDownListComponent
                    label='Tecnologia Secundária'
                    required
                    options={tecnologias}
                    valueField='id'
                    textField='descricao'
                    model={veiculo}
                    modelField='tecnologia_secundaria_id' />
            </div>

            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12  mb-2">
                <TextFieldComponent
                    label="Nº Rastreador Secundário"
                    field='id_rastreador_sec'
                    model={veiculo} />
            </div>

            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12  mb-2">
                <DropDownListComponent
                    label='Comunicação Secundária'
                    required
                    options={tecnologiaComunicacoes}
                    valueField='id'
                    textField='descricao'
                    model={veiculo}
                    modelField='tecnologia_comunicacao_secundaria_id' />
            </div>
        </div>
    );
}

export default VeiculoDadosTab;